import { render, staticRenderFns } from "./YTDSalesChart.vue?vue&type=template&id=1d799977&scoped=true"
import script from "./YTDSalesChart.vue?vue&type=script&lang=js"
export * from "./YTDSalesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d799977",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d799977')) {
      api.createRecord('1d799977', component.options)
    } else {
      api.reload('1d799977', component.options)
    }
    module.hot.accept("./YTDSalesChart.vue?vue&type=template&id=1d799977&scoped=true", function () {
      api.rerender('1d799977', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Dashboard/YTDSalesChart.vue"
export default component.exports